// extracted by css-extract-rspack-plugin
export default {"area":"WJ7glecfcgAQNvut"};